<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!isLoading && orderProcess$ | async as orderProcess" class="component-container">
  <!-- CURRENT STATUS -->
  <div class="margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'overview.process-details.order-process-title' | translate }}</div>
  </div>
  <div class="standard-offer-row ui-g-12 form-font-size mt-2">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g field-label">
        <b>
          {{ 'overview.process-details.current-status' | translate }} :
          {{ 'regep.order-process.' + enums.orderProcessStatus[orderProcess.status] | translate }}
        </b>
      </div>
    </div>

    <div
      *ngIf="
        orderProcess.status !== enums.orderProcessStatus.RequestDenied &&
        orderProcess.status !== enums.orderProcessStatus.RequestWithdrawn &&
        orderProcess.status !== enums.orderProcessStatus.RequestApproved
      "
      class="standard-offer-row ui-g-12 form-font-size">
      <ng-container *ngIf="isUserModerator">
        <div class="mt-2">
          <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="engineeringOk(orderProcess)"
              [disabled]="!isOkPending(orderProcess.status)"
              label="{{ getOkButtonLabel(orderProcess.status) | translate }}"
              pButton
              type="button"></button>
          </div>

          <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="openIssue(orderProcess)"
              [disabled]="!canOpenIssue(orderProcess.status)"
              label="{{ 'regep.result.open-issue-button' | translate }}"
              pButton
              type="button"></button>
          </div>

          <div
            *ngIf="canApproveRequest(orderProcess.status)"
            class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="approveRequest(orderProcess.id)"
              label="{{ 'regep.result.approve-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>

          <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="denyRequest(orderProcess.id)"
              [disabled]="!canDenyRequest(orderProcess.status)"
              label="{{ 'regep.result.deny-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isUserEngineer || isUserCustomer">
        <div class="mt-2">
          <div
            *ngIf="canAddCustomerData(orderProcess.status)"
            class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="customerDataAdded(orderProcess.id)"
              label="{{ 'regep.result.send-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>
          <div
            *ngIf="canUpdateRequest(orderProcess.status)"
            class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="updateRequest(orderProcess)"
              label="{{ 'regep.result.update-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>
          <div
            *ngIf="canWithdrawRequest(orderProcess.status)"
            class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="withdrawRequest(orderProcess.id)"
              label="{{ 'regep.result.withdraw-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>
          <div
            *ngIf="canWithdrawRequest(orderProcess.status)"
            class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
            <button
              class="view-btn-width"
              (click)="withdrawAndCopyRequest(orderProcess.id)"
              id="withdraw-and-copy-request-btn"
              label="{{ 'grid-comp.result.withdraw-and-copy-request-button' | translate }}"
              pButton
              type="button"></button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
